// Capture overlay pro plynulý drag/resize oken nad legacy iframy.
//
// Problém: při tažení/resize s posluchači na `window` kurzor při rychlém pohybu vjede nad iframe,
// který pohltí pointer eventy → tahání seká a přeskakuje. Řešení: na začátku gesta přes celý
// viewport vykreslíme FIXNÍ PRŮHLEDNÝ overlay (z-index nad vším), zavoláme na něm
// `setPointerCapture` a posloucháme `pointermove`/`pointerup` NA NĚM. Overlay leží nad všemi
// iframy → kurzor do iframu nevjede, žádné probublávání. Na konci gesta se overlay odstraní.

export interface DragCaptureHandlers {
  /** Pohyb ukazatele (pointermove na overlayi). */
  readonly onMove: (e: PointerEvent) => void;
  /** Konec gesta (pointerup / pointercancel / ztráta capture). Volá se právě jednou. */
  readonly onEnd: () => void;
}

/**
 * Spustí capture overlay pro dané `pointerId` s daným kurzorem (`move` / `se-resize` …).
 * Vrací funkci pro předčasné ukončení (typicky není potřeba — overlay se ukončí sám na pointerup).
 */
export function beginDragCapture(
  pointerId: number,
  cursor: string,
  handlers: DragCaptureHandlers
): () => void {
  const overlay = document.createElement('div');
  overlay.className = 'pwm-drag-capture';
  overlay.style.cursor = cursor;
  document.body.appendChild(overlay);

  let ended = false;
  const end = () => {
    if (ended) return;
    ended = true;
    overlay.removeEventListener('pointermove', onMove);
    overlay.removeEventListener('pointerup', onUp);
    overlay.removeEventListener('pointercancel', onUp);
    overlay.removeEventListener('lostpointercapture', onUp);
    try {
      overlay.releasePointerCapture(pointerId);
    } catch {
      /* už uvolněno */
    }
    overlay.remove();
    handlers.onEnd();
  };

  const onMove = (e: PointerEvent) => {
    if (!ended) handlers.onMove(e);
  };
  const onUp = () => end();

  overlay.addEventListener('pointermove', onMove);
  overlay.addEventListener('pointerup', onUp);
  overlay.addEventListener('pointercancel', onUp);
  overlay.addEventListener('lostpointercapture', onUp);
  try {
    overlay.setPointerCapture(pointerId);
  } catch {
    // setPointerCapture může selhat (neaktivní pointer) — overlay i tak odchytí eventy nad sebou.
  }

  return end;
}
